/**
 * @generated SignedSource<<4b22eb8c30916385da065fba44b2ab6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteTeamInput = {
  id: any;
};
export type TeamsRouteDeleteTeamMutation$variables = {
  input: DeleteTeamInput;
};
export type TeamsRouteDeleteTeamMutation$data = {
  readonly deleteTeam: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type TeamsRouteDeleteTeamMutation = {
  response: TeamsRouteDeleteTeamMutation$data;
  variables: TeamsRouteDeleteTeamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteTeamPayload",
    "kind": "LinkedField",
    "name": "deleteTeam",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamsRouteDeleteTeamMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamsRouteDeleteTeamMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7f762b4d1e9e3761c62ad1a0b1b9211a",
    "id": null,
    "metadata": {},
    "name": "TeamsRouteDeleteTeamMutation",
    "operationKind": "mutation",
    "text": "mutation TeamsRouteDeleteTeamMutation(\n  $input: DeleteTeamInput!\n) {\n  deleteTeam(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "5cccac73a5ab3781cfcfd46c9312303a";

export default node;
